
// export const BASE_URL = "http://15.165.157.156:8080/acs/api/v1/";
// export const LOGIN_URL = "http://15.165.157.156:8080/auth/login";

export const BASE_URL = "http://localhost:8080/";
// export const LOGIN_URL = "http://3.37.5.79:8080/auth/login";
export const LOGIN_URL = "http://localhost:8080/loginAdmin";


export const fetchHeaders = new Headers({"Content-Type": "application/json"});

